import React, { useEffect, useState, useRef } from 'react';
import { connect } from 'react-redux'
import * as queryString from 'query-string';
import { firstNameFirst, getFirstName } from "../../../helpers/formatting";
import YesNoModal from "../YesNoComponent";
import { withRouter } from "react-router-dom";
import * as Tools from "../../../helpers/Tools";
import * as types from "../../../constants/actionTypes";
import * as msgs from "../../../constants/textConstants";
import { logUI } from "../../../api/andyliticsApi";
import { Button, Card, LinkList, Link, Icon, Typography } from '../../ecosystem/';
import { ProxyList } from '../../ecosystem/mybswh';
import * as d from "../../../reducers/domainReducer";

const SelectPatient = ({ screenBreakPoint, isShowAllUsers, serverData, primaryUser, ...props })=> {
    const [showModal,setShowModal]=useState(false);
    const [modalText, setModalText] = useState(null);
    const [links, setLinks] = useState([]);
    const [modalYesFunction, setModalYesFunction] = useState(null);
    const [modalNoFunction, setModalNoFunction] = useState(null);
    let userSelected = props.userSelected;
    const isMobile = (screenBreakPoint === msgs.XS_MOBILE || screenBreakPoint === msgs.SM_MOBILE) ? true : false;
    const isMybswHealthBundle = serverData && serverData.bundle && serverData.bundle.toLowerCase() === 'mybswhealth' ? true : false;

    const prevPropsRef = useRef();
    useEffect(() => {
        prevPropsRef.current = props;
    });
    const prevProps = prevPropsRef.current;


    useEffect(() => {
        console.info(`### SelectPatient myProxies`, props.myProxies);
        props.myProxies.map((user, index) => {
            const lnk = {
                id: user.externalId,
                onClick: (event) => { onUserSelected(event, user, index); },
                text: <>{index === 0 ? "Myself" : firstNameFirst(user.displayName)} </>,
                disabled: false, /*Not sure when to disable, mainly if they dont have a mychartid but if they are in this list then they should.*/
                as: <button type="button"></button> //Setting as button since does not have route to navigate
            };
            console.info(`### SelectPatient useEffect [] lnk, links`, lnk, links);
            links.push(lnk);
        });
        links.push({
            onClick: gotoProxyRequest,
            text: <>{`+Add or Grant Family Access`}</>,
            to: { pathname: "/proxymanagement" }
        });
    },[]);


    const isValid = () => {
        return userSelected !== null;
    };

    const cancelModal = () => {
        setShowModal(false);
    };

    const gotoProxyRequest = () => {
        console.info(`### SelectPatient gotoProxyRequest`);
        logUI("MBHWeb.UI.ProxyPicker.AddDependent.Clicked", new Date(), Tools.getURLPath());
    }

    const onUserSelected = (event, user, index) => {
        event.preventDefault();
        const { currentUser } = props;
        //debugger;
        if (user.externalId !== currentUser.externalId || user.externalId !== currentUser.externalId) {
            setShowModal(true);
            setModalText();
            setModalNoFunction(() => {
                switchToUser(user, index);
                if (props.onUserSelected) {
                    props.onUserSelected(user);
                }
            });
            setModalNoFunction(cancelModal);
        } else {
            userSelected = user;
            if (props.loadEVisitPage) {
                props.loadEVisitPage(true);
            }
            //debugger;
            // only switch if the user is different, which should be never
            if (user.externalId !== currentUser.externalId || user.externalId !== currentUser.externalId) {
                switchToUser(user, index);
            }

            if (props.onUserSelected) {
                props.onUserSelected(user);
            }
        }

        if (index === 0 &&  props.onClicked)
            props.onClicked();
    }

    const switchToUser = (user, index) => {
        userSelected = user;
        if (props.switchToMyChartUser) {
            props.switchToMyChartUser(user, index);
        }

      
        cancelModal();

    }
  


    const { myProxies, currentUser, className, hasMychart, history, patientProfiles, isMammography, pickerInfo,patients } = props;
    const activeUser = !userSelected ? null : currentUser;
    const styleButton = true;
    const containerClass = "proxy-picker-select-container" + (className ? " " + className : "");
    const Element = isMobile ? 'div' : Card;
    let showPatientButtonDisabledBlurb=false;
    for (var i = 0; i < myProxies.length; i++) {
        myProxies[i].GenderIdentity = patientProfiles[i].patient.GenderIdentity;
        if (patientProfiles[i].patient && patientProfiles[i].patient.GenderIdentity && (((patientProfiles[i].patient.GenderIdentity).toLowerCase() === 'male') || ((patientProfiles[i].patient.GenderIdentity).toLowerCase() === 'female' && patientProfiles[i].patient.AgeYears <= 35)) && isMammography) {
            showPatientButtonDisabledBlurb = true;
        }
    }


    return (<div className={containerClass} style={ props.style}>
        <YesNoModal showModal={showModal} modalText={modalText} modalYesFunction={modalYesFunction} modalNoFunction={modalNoFunction} />
        <div className="row proxy-picker-select__section">
            <div className={"col-12"}>
                <div className={"proxy-picker-select__title"}>
                    <div className={"proxy-picker-select__icon"}>
                        <Icon name={pickerInfo.icon} set={pickerInfo.iconSet} size="large" />
                    </div>
                    <Typography
                        type={isMobile ? "heading-02" : "heading-06"}
                        responsive={isMobile ? false : true }
                    >
                        {pickerInfo.message}
                    </Typography>
                </div>

                <div className={"select-patient-divider"} />
            </div>
            <div className={"col-12"}>
                <Element
                    borderStyle={Element === Card ? 'elevated' : '' }
                >
                    <div className={`proxy-picker-select__list`}>
                        <div key={links.length}>
                            <ProxyList
                                list={links}
                                picker={props.pickerInfo}
                                patients={patients}
                                myProxies={myProxies}
                                currentUser={currentUser}
                                primaryUser={primaryUser}
                                isShowAllUsers={isShowAllUsers}
                                showBadge={isMybswHealthBundle}
                            />
                        </div>
                    </div>
                </Element>
            </div>
        </div>
    </div>);

    
}

const mapStateToProps = (state) => {
    return {
        byPassProxyAndInfo: state.openScheduling.byPassProxyAndInfo,
        patientProfiles: state.memberships.profileList,
        screenBreakPoint: state.common.screenBreakPoint,
        isShowAllUsers: state.dashboard.isShowAllUsers,
        serverData: state.session.serverData,
        primaryUser: d.hydrateProxyUser(state.domain.pu)
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        updateBypassProxyAndInfo: payload => dispatch({ type: types.UPDATE_BYPASS_PROXY_AND_INFO, payload })
    };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps, null)(SelectPatient));
